import {IPlatformCommandHandler, IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {EventEmitter, Injectable} from '@angular/core';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {PlatformCommand} from '@shared/commands/command-base';
import {CommandService} from '@core/services/command.service';
import {FuseSplashScreenService} from '@barebone-fuse/@fuse/services/splash-screen.service';
import {take} from 'rxjs/operators';
import {Subject} from 'rxjs';
import { Router } from '@angular/router';
import { AddThirdPartySuccessAction } from '@features/entity-tracker/et-st-transactions/store/actions/et-structural-transactions.action';

@Injectable({
  providedIn: 'root',
})

export class UpdateAnalyticReportFromTemplateCommandHandler implements IPlatformCommandHandler {
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  magicLinkModelValueChanged: EventEmitter<any>;
  unsubscribe$ = new Subject<void>();
  constructor(private commandService: CommandService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private router: Router) {
  }
    executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
        this.executeCommandToApi(command, handler);
        return true;
    }

  private executeCommandToApi(command: PlatformCommand, handler: IPlatformToolHandler) {
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          console.log('Command Response', commandResponse);
          this.commandService.handleResponse(commandResponse);
          if(commandResponse.fieldValues["PlatformLinkModel"]) {
            handler.magicLinkModelValueChanged.emit({
                id : 'PlatformToolContainerComponent',
                value: commandResponse.fieldValues["PlatformLinkModel"]
            });
          }
          if (commandResponse.fieldValues['RedirectCommand']) {
            this.executeCommandToApi(commandResponse.fieldValues['RedirectCommand'], handler);
            return;
          }
          if (commandResponse.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
          }

          this.invalidateSubject.invalidate();
    },
    error => {
      console.error('Failed To Execute command', error);
      this.fuseSplashScreenService.hide();
    });
    this.fuseSplashScreenService.hide();
  }
}
}
